import { LevelAnnotationMethod } from "building-types/views/elevationAnnotationTypes";
import { DimensionPrecision } from "building-types/views/viewTypes";
import type { ElevationGenerationContext } from "doc/plans/planGeometrySource";
import type { PlanGeometryGeneratorResult } from "doc/plans/planGeometrySourceTypes";
import { getElevationAnnotationProvider } from "lib/house/render/ElevationAnnotationProvider";

export async function elevationAutoAnnotationSlowGeometryGenerator(
  context: ElevationGenerationContext,
): Promise<PlanGeometryGeneratorResult> {
  const annotationProvider = getElevationAnnotationProvider();

  // Deliberately not `await`-ing for this, it's a slow generator
  const annotationGeometry = annotationProvider.getPlanGeometry({
    dimensionPrecision: DimensionPrecision.PRECISION_1_8,
    elevationAnnotationParams: context.elevationAnnotationParams ?? {
      levelAnnotationMethod: LevelAnnotationMethod.FIXED,
    },
    ...context,
  });

  return annotationGeometry;
}
